import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationModel, NotificationStateSlice } from "store/types/notificationSlice.types";

const initialState: NotificationStateSlice = {
  id: 0,
  message: null,
  description: null,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification(state, action: PayloadAction<NotificationModel>) {
      state.id += 1;
      state.message = action.payload.message;
      state.description = action.payload.description ?? null;
    },
  },
});

export const { setNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
